import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ontos_choice_input = _resolveComponent("ontos-choice-input")!

  return (_openBlock(), _createBlock(_component_ontos_choice_input, {
    label: _ctx.$tt('state'),
    form: "dot",
    value: _ctx.value,
    options: _ctx.workflow.coloredStates(),
    multiple: _ctx.multiple,
    readonly: _ctx.readonly,
    required: "",
    "hide-label": _ctx.hideLabel,
    outlined: _ctx.outlined,
    dense: _ctx.dense,
    onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('input', $event)))
  }, null, 8, ["label", "value", "options", "multiple", "readonly", "hide-label", "outlined", "dense"]))
}